import React from 'react';
import PropTypes from 'prop-types';

import fr from 'react-intl/locale-data/fr';
import es from 'react-intl/locale-data/es';
import {IntlProvider, addLocaleData} from 'react-intl';

let ROOT_PATH = 'Content/copy/languages/';
const FILES_EXT = '.json';

class CustomIntlWrapper extends React.Component {
  static propTypes = {
    locale: PropTypes.string,
    messages: PropTypes.object,
    children: PropTypes.any,
  };

  static fetchFile = locale => {
    return fetch(ROOT_PATH.concat(locale, FILES_EXT) + `?v=${window.dateStamp || 1}`)
      .then(res => res.json())
      .catch(e => {
        console.log('Error getting the language: ' + locale + '. Reason: ', e);
      });
  };

  constructor(props) {
    super(props);

    addLocaleData([...fr]);
    addLocaleData([...es]);

    this.state = { };
  }

  render() {


    return <IntlProvider locale={this.props.locale} messages={this.props.messages} {...this.props}>
      {this.props.children}
    </IntlProvider>;
  }
}

export default CustomIntlWrapper;
